// extracted by mini-css-extract-plugin
export default {"wrapper":"BaseBlock_wrapper__R8mSt","base_block":"BaseBlock_base_block__TsBgu","title":"BaseBlock_title__hwqSs"};